



















































































































































































































































































































import { defineComponent, PropType } from '@nuxtjs/composition-api'
import Vue from 'vue'
import { mapState, mapGetters, mapActions } from 'vuex'
import UtilButtons from '~/components/car/classifieds/view/partials/UtilButtons.vue'
import CompareViewService from '~/services/compare/CompareViewService'
import Title from '~/components/car/classifieds/view/partials/Header/Title.vue'
import SellerInfo from '~/components/car/classifieds/view/partials/seller/SellerInfo.vue'
import VerifiedUser from '~/components/car/classifieds/view/partials/VerifiedUser.vue'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import ReportButton from '~/components/car/classifieds/view/partials/Header/ReportButton.vue'
import ShareButton from '~/components/car/classifieds/view/partials/Header/ShareButton.vue'
import PrintButton from '~/components/car/classifieds/view/partials/Header/PrintButton.vue'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import Price from '~/components/plot/classifieds/view/partials/Price.vue'
import CClassifiedFavoriteButton from '~/components/shared/configurable/classified/bucket/favorite/CClassifiedFavoriteButton.vue'
import { USER_NS } from '~/store/modules/shared/user/state'
import CClassifiedCompareButton from '~/components/shared/configurable/classified/compare/CClassifiedCompareButton.vue'
import { comparableRootCategoryIds } from '~/constants/compare'
import PromotedBadge from '~/components/car/classifieds/badges/PromotedBadge.vue'
import CGoogleAd from '~/components/shared/configurable/ad/CGoogleAd.vue'
import { ADS_NS } from '~/store/modules/shared/ads/state'
import PaidClassifiedBadge from '~/components/car/classifieds/badges/PaidClassifiedBadge.vue'
import Specifications from '~/components/plot/classifieds/view/partials/Specifications.vue'
import QuickSellerInfo from '~/components/shared/classified/view/QuickSellerInfo.vue'
import { OfferType } from '~/models/classified/types'
import {
  plotViewDesktopTopGoogleAd,
  plotViewMobileBottomGoogleAd,
  plotViewMobileTopGoogleAd
} from '~/constants/ads/view'
import ClassifiedViewAd from '~/components/car/classifieds/view/ClassifiedViewAd.vue'
import ClassifiedListsButton from '~/components/shared/parking/partials/ClassifiedListsButton.vue'
import PromoteBlock from '~/components/car/classifieds/view/partials/PromoteBlock.vue'
import RelatedClassifiedsAndSearches from '~/components/shared/classified/view/RelatedClassifiedsAndSearches.vue'
import { getRouteMetaItem } from '~/utils/router'
import { elementLargerThanScreen } from '~/utils/dom'
import PerpetratorInfo from '~/components/car/classifieds/view/admin/PerpetratorInfo.vue'
import OffersButton from '~/components/shared/classified/offers/OffersButton.vue'
import { OnlineLoanType } from '~/constants/loan/loans'
import ViewMobileInfo from '~/components/car/classifieds/view/partials/ViewMobileInfo.vue'
import { defineVue3AsyncComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: {
    OffersButton,
    RelatedClassifiedsAndSearches,
    PromoteBlock,
    CFloatingContactParking: defineVue3AsyncComponent(() =>
      import('~/components/shared/configurable/CFloatingContactParking.vue')
    ),
    PerpetratorInfo,
    ClassifiedListsButton,
    QuickSellerInfo,
    Specifications,
    PaidClassifiedBadge,
    CGoogleAd,
    PromotedBadge,
    Extras: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/partials/Extras.vue')
    ),
    Description: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/partials/Description.vue')
    ),
    Notes: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/partials/Notes.vue')
    ),
    ProtectedUtilButtons: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/ProtectedUtilsButtons/ProtectedUtilButtons.vue'
      )
    ),
    UtilButtons,
    Map: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/partials/Map.vue')
    ),
    PriceChangesChart: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/partials/PriceChangesChart.vue')
    ),
    ContactPrompt: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/partials/ContactPrompt.vue')
    ),
    Price,
    Title,
    Contact: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/partials/Contact.vue')
    ),
    ViewMobileInfo,
    SellerInfo,
    CClassifiedFavoriteButton,
    ReportButton,
    ShareButton,
    PrintButton,
    VerifiedUser,
    CClassifiedCompareButton,
    ClassifiedViewAd,
    TradesBlock: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/partials/TradesBlock.vue')
    ),
    OnlyTradesAlert: defineVue3AsyncComponent(() =>
      import('~/components/car/classifieds/view/partials/OnlyTradesAlert.vue')
    ),
    PiraeusLoanButton: defineVue3AsyncComponent(() =>
      import(
        '~/components/plot/classifieds/view/piraeus-loan/PiraeusLoanButton.vue'
      )
    )
  },
  props: {
    offertype: {
      type: String as PropType<OfferType>,
      default: ''
    }
  },
  data() {
    return {
      goToMessagesOnLoad: false,
      forceBottom: false
    }
  },
  computed: {
    componentInstance(): Vue {
      return this
    },
    compareViewService() {
      return this.$dep(CompareViewService)
    },
    sellerIsVerified(): Boolean {
      return this.seller?.verification?.creditCardVerified || false
    },
    ads() {
      return {
        plotViewMobileTopGoogleAd,
        plotViewMobileBottomGoogleAd,
        plotViewDesktopTopGoogleAd
      }
    },
    ...mapState(ADS_NS, {
      showAdmanAds: state => state.showAdmanAds
    }),
    ...mapState(CLASSIFIED_VIEW_NS, {
      classified: state => state.classified,
      refs: state => state.refs,
      seller: state => state.seller,
      showContact: state => state.showContact,
      showContactPrompt: state => state.showContactPrompt,
      classifiedId: state => state.classifiedId,
      currentUser: state => state.currentUser,
      installments: state => state.installments
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      isWanted: 'isWanted',
      isPromoted: 'isPromoted',
      sellerIsAnonymous: 'sellerIsAnonymous',
      sellerIsGuest: 'sellerIsGuest',
      sellerIsSingle: 'sellerIsSingle',
      classifiedIsDeleted: 'isDeleted',
      shouldShowProtectedUtilButtons: 'shouldShowProtectedUtilButtons',
      userCanViewNotes: 'userCanViewNotes',
      userIsAdminOrOwner: 'userIsAdminOrOwner',
      adsKeyValues: 'getKeyValues',
      paidClassified: 'paidClassified',
      isMapVariant: 'isMapVariant',
      canViewPromotionInfo: 'canViewPromotionInfo',
      isOnlyTrades: 'isOnlyTrades',
      showLoanSection: 'showLoanSection'
    }),
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile',
      isPc: 'isPc'
    }),

    ...mapGetters(USER_NS, {
      isAdmin: 'isAdmin'
    }),
    ...mapGetters(USER_NS, {
      userHasPermission: 'hasPermission'
    }),
    categoryId(): number {
      return comparableRootCategoryIds.find(c =>
        this.classified.category_ids.includes(c)
      )
    },
    isPlotSearch() {
      return getRouteMetaItem(this.$route, 'plotSearch')
    },
    showPromoBadge() {
      if (this.isPromoted) {
        return this.$route.query['from-promotion'] || this.userIsAdminOrOwner
      }
      return false
    },
    hasTrades() {
      return !!Object.keys(this.classified?.trades?.categories || {}).length
    },
    OnlineLoanType() {
      return OnlineLoanType
    }
  },
  async updated() {
    await this.$nextTick()
    this.forceBottom = elementLargerThanScreen(this.$refs.rightcol)
  },
  mounted() {
    this.$emit('mounted')

    if (this.refs && this.refs.goToMessagesOnLoad) {
      this.goToMessagesOnLoad = this.refs.goToMessagesOnLoad
    }
    this.$store.commit('classifieds/view/SET_REFS', null)
    this.forceBottom = elementLargerThanScreen(this.$refs.rightcol)
  },
  methods: {
    ...mapActions(CLASSIFIED_VIEW_NS, {
      classifiedParkedStateChanged: 'classifiedParkedStateChanged'
    })
  }
})
